/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IInterProcessApiConfigurationControllerScope extends angular.IScope {
        processConfigId: string;
        interProcessApis: Wars.Domain.Model.InterProcessApi[];
        selectedInterProcessApi: Wars.Domain.Model.InterProcessApi;
        isReadonly: boolean;
        processSchemaProperties: Wars.Domain.Model.SchemaProperty[];
        processTypes: Wars.Domain.Model.ProcessType[];
        codeGroups: Wars.Domain.Model.Codes.CodeGroup[];
        otherProcessSchemaProperties: Wars.Domain.Model.SchemaProperty[];
        otherProcessCalculations: Wars.Domain.Model.Calculations.Calculation[];
        
        processTypeChanged() : void;
        save(): void;
        cancel(): void;
        addInterProcessApi(): void;
        addOutputMapping() : void;
        editInterProcessApi(interProcessApi: Wars.Domain.Model.InterProcessApi): void;
        deleteInterProcessApi(interProcessApi: Wars.Domain.Model.InterProcessApi): void;
        deleteOutputMapping(outputMapping: Wars.Domain.Model.InterProcessOutputMapping): void;
        getOutputSchemaProperties(): Wars.Domain.Model.SchemaProperty[];
    }

    export class InterProcessApiConfigurationController implements IController {
        constructor(
            private scope: IInterProcessApiConfigurationControllerScope,
            $routeParams: angular.route.IRouteParamsService,
            private processConfigurationService: services.ProcessConfigurationService,
            private processTypeService: services.ProcessTypeService,
            private interProcessApiService: services.InterProcessApiService,
            private systemLevelService: services.SystemLevelService,
            private manageSystemCodesService: services.ManageSystemCodesService,
            private objectSchemaService: services.ObjectSchemaService,
            private growlService: angular.growl.IGrowlService,
            private deleteService: services.DeleteService)
        {
            this.scope.processConfigId = $routeParams["id"];
            // TODO: set this based on whether the process configuration is editable or not
            this.scope.isReadonly = false;

            this.interProcessApiService.getInterProcessApis(this.scope.processConfigId).then((apis) => {
                this.scope.interProcessApis = apis;
            });

            this.processConfigurationService.getProcessSchemaProperties(this.scope.processConfigId).then((schemaProperties) => {
                this.scope.processSchemaProperties = schemaProperties;
            });

            this.processTypeService.getAllProcessTypes().then((processTypes) => {
                this.scope.processTypes = processTypes;
            });

            this.loadCodes();

            this.scope.processTypeChanged = () => {
                this.loadOtherProcessSchemaProperties();
                this.loadOtherProcessCalculations();
            };
            this.scope.save = () => this.save();
            this.scope.cancel = () => this.cancel();
            this.scope.addInterProcessApi = () => this.addInterProcessApi();
            this.scope.addOutputMapping = () => this.addOutputMapping();
            this.scope.editInterProcessApi = (interProcessApi: Wars.Domain.Model.InterProcessApi) => this.editInterProcessApi(interProcessApi);
            this.scope.deleteInterProcessApi = (interProcessApi: Wars.Domain.Model.InterProcessApi) => this.deleteInterProcessApi(interProcessApi);
            this.scope.deleteOutputMapping = (outputMapping: Wars.Domain.Model.InterProcessOutputMapping) => this.deleteOutputMapping(outputMapping);
            this.scope.getOutputSchemaProperties = () => this.getOutputSchemaProperties();
        }

        private save(): void {
            var validationResults = this.objectSchemaService.validateObjectSchema(this.scope.selectedInterProcessApi.myOutputSchema);
            if (validationResults.length === 0) {
                this.interProcessApiService.saveAllChanges();
            } else {
                validationResults.forEach(error => this.growlService.error(error));
            }
        }

        private cancel(): void {
            this.interProcessApiService.rejectChanges();
            this.scope.selectedInterProcessApi = undefined;
        }

        private addInterProcessApi(): void {
            var newApi = this.interProcessApiService.createInterProcessApi(this.scope.processConfigId);

            newApi.myOutputSchema = this.objectSchemaService.createNewObjectSchema();
            newApi.outputSchema_id = newApi.myOutputSchema.id;

            this.scope.interProcessApis.push(newApi);
            this.scope.selectedInterProcessApi = newApi;
            this.save();
        }

        private addOutputMapping(): void {
            var newMapping = this.interProcessApiService.createInterProcessOutputMapping(this.scope.selectedInterProcessApi.id);
            this.scope.selectedInterProcessApi.myOutputMappings.push(newMapping);
        }

        private editInterProcessApi(interProcessApi: Wars.Domain.Model.InterProcessApi): void {
            if (this.interProcessApiService.hasChanges()) {
                alert("Please save or cancel your current changes before editing a new Inter Process API.");
                return;
            }
            this.scope.selectedInterProcessApi = interProcessApi;
            this.loadOtherProcessSchemaProperties();
            this.loadOtherProcessCalculations();
        }

        private deleteInterProcessApi(interProcessApi: Wars.Domain.Model.InterProcessApi): void {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "InterProcessApi",
                interProcessApi.id,
                "Inter-Process API",
                () => {
                    this.scope.interProcessApis.remove(interProcessApi);
                    this.scope.selectedInterProcessApi = undefined;
                });
        }

        private deleteOutputMapping(outputMapping: Wars.Domain.Model.InterProcessOutputMapping): void {
            outputMapping.entityAspect.setDeleted();
            this.scope.selectedInterProcessApi.myOutputMappings.remove(outputMapping);
        }

        /// This is a method and not just using the properties directly so when we allow list data the changes will be more seamless
        private getOutputSchemaProperties(): Wars.Domain.Model.SchemaProperty[] {
            if (this.scope.selectedInterProcessApi) {
                return this.scope.selectedInterProcessApi.myOutputSchema.properties;
            }
            return [];
        }

        private loadCodes(): void {
            this.systemLevelService.getSystemLevelCodes().then(
                (systemLevel) => {
                    this.scope.codeGroups = systemLevel.myCodeGroups;
                    if (this.scope.processConfigId) {
                        this.manageSystemCodesService.getAllCodesForProcessConfiguration(this.scope.processConfigId).then(
                            (codeGroups) => {
                                this.scope.codeGroups = this.scope.codeGroups.concat(codeGroups);
                            });
                    }
                });
        }

        private loadOtherProcessSchemaProperties() {
            if (this.scope.selectedInterProcessApi && this.scope.selectedInterProcessApi.processType_id) {
                this.processTypeService.getByIdEagerLoadAppConfigs(this.scope.selectedInterProcessApi.processType_id)
                    .then((processType) => {
                        if (!processType) {
                            this.scope.otherProcessSchemaProperties = [];
                        } else {
                            var inWorkProcessConfig = Enumerable.from(processType.processConfigurations)
                                .single(i => i.minorVersion == null);

                            this.processConfigurationService.getTopLevelSchemaProperties(inWorkProcessConfig.id)
                                .then((schemaProperties) => {
                                    this.scope.otherProcessSchemaProperties = schemaProperties;
                                });
                        }
                    });
            } else {
                this.scope.otherProcessSchemaProperties = [];
            }
        }

        private loadOtherProcessCalculations() {
            if (this.scope.selectedInterProcessApi && this.scope.selectedInterProcessApi.processType_id) {
                this.processTypeService.getByIdEagerLoadAppConfigs(this.scope.selectedInterProcessApi.processType_id)
                    .then((processType) => {
                        if (!processType) {
                            this.scope.otherProcessCalculations = [];
                        } else {
                            var inWorkProcessConfig = Enumerable.from(processType.processConfigurations)
                                .single(i => i.minorVersion == null);

                            this.processConfigurationService.getProcessConfigurationEagerLoadCalculations(inWorkProcessConfig.id)
                                .then((processConfig) => {
                                    this.scope.otherProcessCalculations = processConfig.myCalculations;
                                });
                        }
                    });
            } else {
                this.scope.otherProcessCalculations = [];
            }
        }
    }
}

warsApp.registerController('InterProcessApiConfigurationController', [
    "$scope", "$routeParams", "processConfigurationService", "processTypeService", "interProcessApiService",
    "systemLevelService", "manageSystemCodesService", "objectSchemaService", "growl", "deleteService"]);